// Security utility functions for Admin panel

// Sanitize input to prevent XSS attacks
export const sanitizeInput = (input) => {
  if (typeof input === 'string') {
    return input
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/\//g, '&#x2F;');
  }
  return input;
};

// Sanitize HTML content
export const sanitizeHTML = (html) => {
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
};

// Validate email format
export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

// Validate mobile number format
export const validateMobile = (mobile) => {
  const re = /^\d{10,15}$/;
  return re.test(mobile);
};

// Validate password strength
export const validatePassword = (password) => {
  // At least 8 characters, one uppercase, one lowercase, one number
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/;
  return re.test(password);
};

// Escape HTML special characters
export const escapeHTML = (str) => {
  return str.replace(/[&<>"']/g, 
    tag => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[tag])
  );
};

// Validate URL
export const validateURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

// Remove script tags from content
export const removeScriptTags = (content) => {
  if (typeof content !== 'string') return content;
  return content.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
};

// Sanitize user input for forms
export const sanitizeFormInput = (data) => {
  const sanitized = {};
  for (const key in data) {
    if (typeof data[key] === 'string') {
      // Remove script tags and sanitize
      sanitized[key] = sanitizeInput(removeScriptTags(data[key]));
    } else if (typeof data[key] === 'object' && data[key] !== null) {
      // Recursively sanitize objects
      sanitized[key] = sanitizeFormInput(data[key]);
    } else {
      sanitized[key] = data[key];
    }
  }
  return sanitized;
};

// Validate file type for uploads
export const validateFileType = (file, allowedTypes) => {
  return allowedTypes.includes(file.type);
};

// Validate file size (in bytes)
export const validateFileSize = (file, maxSize) => {
  return file.size <= maxSize;
};

export default {
  sanitizeInput,
  sanitizeHTML,
  validateEmail,
  validateMobile,
  validatePassword,
  escapeHTML,
  validateURL,
  removeScriptTags,
  sanitizeFormInput,
  validateFileType,
  validateFileSize
};